import {
  QUICK_FILL_APPLY_SUBMIT,
  QUICK_FILL_APPLY_SUCCESS,
  QUICK_FILL_APPLY_FAILURE,
  QUICK_FILL_UNDO_SUBMIT,
  QUICK_FILL_UNDO_SUCCESS,
  QUICK_FILL_UNDO_FAILURE
} from './constants'

export const quickFillApplySubmit = payload => ({ payload, type: QUICK_FILL_APPLY_SUBMIT })
export const quickFillApplySuccess = payload => ({ payload, type: QUICK_FILL_APPLY_SUCCESS })
export const quickFillApplyFailure = payload => ({ payload, type: QUICK_FILL_APPLY_FAILURE })

export const quickFillUndoSubmit = payload => ({ payload, type: QUICK_FILL_UNDO_SUBMIT })
export const quickFillUndoSuccess = payload => ({ payload, type: QUICK_FILL_UNDO_SUCCESS })
export const quickFillUndoFailure = payload => ({ payload, type: QUICK_FILL_UNDO_FAILURE })
